module.exports = __webpack_public_path__ + "static/media/Lima-Framework.b2f7a058.pdf";